module.exports = __webpack_public_path__ + "img/tooth_camera.7e00bfb1.jpg";